/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useRef, useState} from 'react';
import {Teams, Utils} from '../../../utils/api';
import {ARMcontext} from '../../../utils/context/context';
import {useInputValue} from '../../../utils/hooks/useInputValue';
import {Badge, InputComponent, LargeButton, PowerDropdown, Label, BadgeImage, TextWarning, Loader} from '../../../components';
import {
  CtBody,
  CtFooter,
  CtBodyLeft,
  CtBodyRigth,
  CtBodyLeftWrapper,
  CtBodyRigthWrapper,
  CtBodyInputContainer,
  CtBodyInputContainerInitial,
  CtBodyRigthWrapperBottom,
  CtBodyRigthWrapperBottomInner,
} from './styles';
import { queryClient } from '../../../utils/helpers/queryClient';

const DefaultCities = [{name: 'Denver'}, {name: 'New york'}, {name: 'Kansas'}];
const DefaultStates = [{name: 'CO'}, {name: 'KA'}, {name: 'WS'}];
const DefaultPallette = [
  {badge: 'NULL', color: 'rgba(253,185,18,1)', title: ''},
  {badge: 'NULL', color: 'rgba(253,139,18,1)', title: ''},
  {badge: 'NULL', color: 'rgba(207,153,95,1)', title: ''},
  {badge: 'NULL', color: 'rgba(150,60,21,1)', title: ''},
  {badge: 'NULL', color: 'rgba(80,180,128,1)', title: ''},
  {badge: 'NULL', color: 'rgba(132,192,193,1)', title: ''},
  {badge: 'NULL', color: 'rgba(62,174,242,1)', title: ''},
  {badge: 'NULL', color: 'rgba(32,121,194,1)', title: ''},
  {badge: 'NULL', color: 'rgba(71,55,255,1)', title: ''},
  {badge: 'NULL', color: 'rgba(102,124,255,1)', title: ''},
  {badge: 'NULL', color: 'rgba(156,85,239,1)', title: ''},
  {badge: 'NULL', color: 'rgba(126,73,184,1)', title: ''},
  {badge: 'NULL', color: 'rgba(240,120,255,1)', title: ''},
  {badge: 'NULL', color: 'rgba(248,73,88,0.9)', title: ''},
  {badge: 'NULL', color: 'rgba(255,94,85,1)', title: ''},
  {badge: 'NULL', color: 'rgba(97,99,102,1)', title: ''},
  {badge: 'NULL', color: 'rgba(26,57,92,1)', title: ''},
];

export default ({HandleEditTeam}: {HandleEditTeam: (value?: boolean) => void}) => {
  const teamLogoRef = useRef<HTMLInputElement | any>(document.createElement('input'));
  const [pallette, usePallette] = useState<any>(DefaultPallette[0]);
  const [defaultCities, useDefaultCities] = useState<any>(DefaultCities);
  const [defaultStates, useDefaultStates] = useState<any>(DefaultStates);
  const [states, useStates] = useState<any>(DefaultStates[0]);
  const [city, useCity] = useState<any>(DefaultCities[0]);
  const {HandleToastMessage} = useContext(ARMcontext);
  const [loading, useLoading] = useState(false);
  const [image, useImage] = useState<any>('');
  const TeamName = useInputValue('');
  const TeamBadge = useInputValue('');
  const Team = new Teams();
  const UTILS = new Utils();
  const validateAlphaNumeric = UTILS.GetValidationWordsAndNumbers();

  useEffect(() => {
    BuildStates();
  }, []);
  useEffect(() => {
    TeamBadge.HandleValue(TeamBadge.value.toUpperCase());
  }, [TeamBadge.value]);

  useEffect(() => {
    if (TeamBadge.value.length < 2) {
      TeamBadge.HandleValue(TeamName.value.toUpperCase().substring(0, 2));
    }
  }, [TeamName.value]);

  async function BuildStates() {
    const result = await Team.GetStates();
    if (result.status) {
      useDefaultStates(result.data);
      useStates(result.data[0]);
      GetCities(result.data[0]._id);
    }
  }

  async function GetCities(cityId: string) {
    const cities = await Team.GetCities(cityId);
    if (cities.status) {
      useDefaultCities(cities.data);
      useCity(cities.data[0]);
    }
  }

  function ChangeCity(selectedOption: any): void {
    useCity(selectedOption);
  }

  function ChangeStates(selectedOption: any): void {
    useStates(selectedOption);
    GetCities(selectedOption._id);
  }

  function ChangePallette(selectedOption: any): void {
    usePallette(selectedOption);
  }

  function ChangeImage(selectedOption: any): void {
    useImage(selectedOption);
  }

  function DeleteTeamLogo(): void {
    ChangeImage('');
  }

  function handleUploadTeamLogo(): void {
    teamLogoRef.current.click();
    teamLogoRef.current.onchange = () => ChangeImage(teamLogoRef.current.files[0]);
  }

  function HandleFocus(e: any) {
    if (e === '1') {
      AlternateFocus(TeamName);
    } else if (e === '2') {
      AlternateFocus(TeamBadge);
    }
  }

  function AlternateFocus(hook: any) {
    hook.HandleStatus('normal');
    hook.HandleWarning('');
  }

  async function handleSubmit(): Promise<void> {
    let error = 0;

    if (!Boolean(TeamName.value.length > 0)) {
      TeamName.HandleWarning('This field cannot be empty');
      TeamName.HandleStatus('error');
      error++;
    }
    if (!Boolean(TeamBadge.value.length > 0)) {
      TeamBadge.HandleWarning('This field cannot be empty');
      TeamBadge.HandleStatus('error');
      error++;
    }
    if (!Boolean(validateAlphaNumeric.test(TeamBadge.value))) {
      TeamBadge.HandleWarning('Enter a valid input');
      TeamBadge.HandleStatus('error');
      error++;
    }
    if (!Boolean(validateAlphaNumeric.test(TeamName.value))) {
      TeamName.HandleWarning('Enter a valid input');
      TeamName.HandleStatus('error');
      error++;
    }

    if (!error) {
      useLoading(true);
      let res: any = {};
      if (image) {
        const resultImage = await UTILS.UploadFile(image);
        res = await Team.createTeam(TeamName.value, pallette.color, TeamBadge.value, city.name, states.name, resultImage.data.path);
      } else {
        res = await Team.createTeam(TeamName.value, pallette.color, TeamBadge.value, city.name, states.name);
      }
      if (res.status) {
        queryClient.clear();
        HandleEditTeam(false);
        HandleToastMessage('Team created succesfully', true, 2000, 'success');
      } else {
        console.log(res);
        const errorMessage = res?.data?.error.charAt(0).toUpperCase() + res?.data?.error.slice(1) || 'Team not created';
        HandleToastMessage(errorMessage, true, 2000, 'error');
      }
      useLoading(false);
    }
  }

  return (
    <>
      <CtBody>
        <CtBodyLeft>
          <CtBodyLeftWrapper>
            {!image ? (
              <Badge
                initial={true}
                text={TeamBadge.value}
                size="140px"
                font="70px"
                family="Proxima Nova"
                color={pallette.color}
                weight="500"
              />
            ) : (
              <BadgeImage srcImage={URL.createObjectURL(image)} callback={DeleteTeamLogo} />
            )}
          </CtBodyLeftWrapper>
          <CtBodyLeftWrapper>
            <input ref={teamLogoRef} type="file" accept="image/png, image/jpeg" style={{display: 'none'}} />
            <LargeButton callback={handleUploadTeamLogo} rColor="#ACB1C0" lColor="#979CA9" icon="uploadImage" title="UPLOAD TEAM LOGO" />
          </CtBodyLeftWrapper>
        </CtBodyLeft>
        <CtBodyRigth>
          <CtBodyRigthWrapper>
            <Label text="Team name" />
            <CtBodyInputContainer>
              <InputComponent
                placeholder="Team name"
                animateWidth="100%"
                dynamicSearch={TeamName}
                idKey="1"
                HandleFocus={HandleFocus}
                maxLength={50}
              />
            </CtBodyInputContainer>
            <TextWarning status={TeamName.status} message={TeamName.warningMessage} />
          </CtBodyRigthWrapper>
          <CtBodyRigthWrapper>
            <Label text="State" />
            <CtBodyInputContainer>
              <PowerDropdown
                dataArray={defaultStates}
                primaryTitle={states.name}
                onClick={ChangeStates}
                search={false}
                mWidth="96%"
                mPadding="4px 0 4px 10px"
                mHeigth="200px"
              />
            </CtBodyInputContainer>
          </CtBodyRigthWrapper>
          <CtBodyRigthWrapper>
            <Label text="City" />
            <CtBodyInputContainer>
              <PowerDropdown
                dataArray={defaultCities}
                primaryTitle={city.name}
                onClick={ChangeCity}
                search={false}
                mWidth="96%"
                mPadding="4px 0 4px 10px"
                mHeigth="200px"
              />
            </CtBodyInputContainer>
          </CtBodyRigthWrapper>
          <CtBodyRigthWrapperBottom>
            <CtBodyRigthWrapperBottomInner>
              <Label text="Color" />
              <CtBodyInputContainer>
                <PowerDropdown
                  dataArray={DefaultPallette}
                  badge={pallette.badge}
                  colorBadge={pallette.color}
                  onClick={ChangePallette}
                  search={false}
                  mHeigth={'100px'}
                  mWidth="90%"
                  mPadding="4px 0 4px 10px"
                />
              </CtBodyInputContainer>
            </CtBodyRigthWrapperBottomInner>
            <div>
              <Label text="Initial" />
              <CtBodyInputContainerInitial>
                <InputComponent animateWidth="70px" dynamicSearch={TeamBadge} maxLength={2} HandleFocus={HandleFocus} idKey="2" />
              </CtBodyInputContainerInitial>
              <TextWarning status={TeamBadge.status} message={TeamBadge.warningMessage} />
            </div>
          </CtBodyRigthWrapperBottom>
        </CtBodyRigth>
      </CtBody>
      <CtFooter>
        <LargeButton
          callback={() => HandleEditTeam(false)}
          rColor="#ffffff"
          lColor="#ffffff"
          title="CANCEL"
          fColor="#5D6C76"
          bColor="#F0F0F0"
          lMargin="0"
          xMargin="0 10px 0 0"
        />
        {loading ? (
          <Loader width="190px" />
        ) : (
          <LargeButton callback={handleSubmit} rColor="#007AFF" lColor="#006BE1" icon="plus" title="CREATE TEAM" />
        )}
      </CtFooter>
    </>
  );
};
